// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var UserTitle = function (x) {
    return x;
};
var tsBridgeUserTitle = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("UserTitle")("__brandUserTitle"));
    }
};
var writeUserTitle = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showUserTitle = Data_Show.showString;
var readUserTitle = Simple_JSON.readString;
var ordUserTitle = Data_Ord.ordString;
var newtypeUserTitle = {
    Coercible0: function () {
        return undefined;
    }
};
var makeUserTitle = UserTitle;
var eqUserTitle = Data_Eq.eqString;
export {
    UserTitle,
    makeUserTitle,
    unwrap,
    newtypeUserTitle,
    eqUserTitle,
    ordUserTitle,
    showUserTitle,
    readUserTitle,
    writeUserTitle,
    tsBridgeUserTitle
};
//# sourceMappingURL=index.js.map
